import _ from 'lodash';

export const fillAccountModelAdapter = (model, form) => {
  _.forEach(model, (value, key) => {
    // We need a given value (the iban to split into the account details)
    if (value && angular.isString(value) && form[`${key}-accountnumber`] && form[`${key}-bankcode`]) {
      // Create new model property to store the account details
      let accountKey = `${key}Account`;
      if (angular.isUndefined(model[accountKey])) {
        model[accountKey] = {};
      }

      // Read account values from given iban value
      let account = {};
      model[accountKey].accountNumber = account.accountNumber = value.replace(/\s+/g, '').substr(12);
      model[accountKey].bankIdentifier = account.bankIdentifier = value.replace(/\s+/g, '').substr(4,8);

      // Set the newly created account details to the mapped model key.
      // Ensure we delete the original model property before submit,
      // otherwise the backend is confused if we send data in the wrong format.
      model[key] = { account };
    }
  });
};

export const prepareAccountModelAdapter = (model) => {
  // Map account details to its own property with 'Account'-Suffix
  _.forEach(model, (value, key) => {
    if (value && angular.isObject(value.account)) {
      model[`${key}Account`] = value.account;
      delete model[key];
    }
  });
  return model;
};
